import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "13",
  height: "13",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M4.59375 4.59375V3.16468C4.59375 2.59296 4.59375 2.30689 4.70501 2.08852C4.80288 1.89644 4.95894 1.74038 5.15102 1.64251C5.36939 1.53125 5.65546 1.53125 6.22718 1.53125H9.08552C9.65724 1.53125 9.94295 1.53125 10.1613 1.64251C10.3534 1.74038 10.5097 1.89644 10.6076 2.08852C10.7189 2.30689 10.7189 2.59275 10.7189 3.16447V6.02282C10.7189 6.59454 10.7189 6.8804 10.6076 7.09877C10.5097 7.29085 10.3532 7.44722 10.1612 7.5451C9.94301 7.65625 9.6576 7.65625 9.08699 7.65625H7.65625M4.59375 4.59375H3.16468C2.59296 4.59375 2.30689 4.59375 2.08852 4.70501C1.89644 4.80289 1.74038 4.95894 1.64251 5.15102C1.53125 5.36939 1.53125 5.65546 1.53125 6.22718V9.08552C1.53125 9.65724 1.53125 9.94295 1.64251 10.1613C1.74038 10.3534 1.89644 10.5097 2.08852 10.6076C2.30668 10.7188 2.5924 10.7188 3.163 10.7188H6.02473C6.59533 10.7188 6.88066 10.7188 7.09881 10.6076C7.2909 10.5097 7.44722 10.3532 7.54509 10.1612C7.65625 9.94301 7.65625 9.6576 7.65625 9.08699V7.65625M4.59375 4.59375H6.02302C6.59474 4.59375 6.88045 4.59375 7.09881 4.70501C7.2909 4.80289 7.44722 4.95894 7.54509 5.15102C7.65625 5.36918 7.65625 5.65491 7.65625 6.22552L7.65625 7.65625",
      stroke: "white",
      "stroke-width": "1.4",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }